import React from 'react'

import Address, { Text } from '~/components/address'
import { CardAction } from '~/components/card'
import { i18n } from '~/i18n'
import { sameAddress } from '~/utils/address'
import formatCurrency from '~/utils/format-currency'

import PaymentMethod from './components/payment-method.component'
import {
  StyledCard,
  SubHeader,
  StyledCardHeader,
  Title,
} from './payment-summary-v3.styles'

import type {
  Address as AddressType,
  TokenizedCreditCard,
  PaymentService,
} from '~/types'

export type Props = {
  billingAddress: AddressType
  shippingAddress: AddressType
  sameAddress: boolean
  onEditPaymentDetails?: () => void
  creditCard?: TokenizedCreditCard | null | undefined
  foundationDonation: number
  paymentService?: PaymentService
} // used at review / payment page in checkout

export default function PaymentSummaryV3(props: Props) {
  const {
    billingAddress,
    shippingAddress,
    onEditPaymentDetails,
    creditCard,
    foundationDonation,
    paymentService,
  } = props

  const billingContent = sameAddress(shippingAddress, billingAddress) ? (
    i18n.t('pages.review.payment_details.same_address_v2')
  ) : (
    <Address address={billingAddress} />
  )

  return (
    <StyledCard>
      <StyledCardHeader>
        <Title>{i18n.t('components.payment_summary.title')}</Title>
        {onEditPaymentDetails && (
          <CardAction onClick={onEditPaymentDetails}>
            {i18n.t('components.substep.edit_btn')}
          </CardAction>
        )}
      </StyledCardHeader>
      <SubHeader>
        {i18n.t('pages.review.payment_details.shipping_address')}
      </SubHeader>
      <Address address={shippingAddress} />
      <SubHeader>
        {i18n.t('pages.review.payment_details.billing_address')}
      </SubHeader>
      {billingContent}
      <SubHeader>
        {i18n.t('pages.review.payment_details.payment_method')}
      </SubHeader>
      <PaymentMethod creditCard={creditCard} paymentService={paymentService} />
      {foundationDonation > 0 && (
        <>
          <SubHeader>
            {i18n.t('pages.review.payment_details.donation_heading')}
          </SubHeader>
          <Text>
            {i18n.t('pages.review.payment_details.donation_short', {
              amount: formatCurrency(foundationDonation),
            })}
          </Text>
        </>
      )}
    </StyledCard>
  )
}
